import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormatter',
  standalone: true,
})
export class PhoneFormatterPipe implements PipeTransform {
  transform(rawPhoneNumber: string): string {

    if (!rawPhoneNumber) {
      return rawPhoneNumber;
    }

    const clean = rawPhoneNumber.replace(/\D/g, '');
    const match = clean.match(/^(\d{3})(\d{3})(\d{4})$/);

    if(match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    } else {
      return rawPhoneNumber;
    }
  }
}
